import Card from "../../components/Card";
import Label from "../../components/Label";
import Button from "../../components/buttons/Button";
import BusinessPage from "./BusinessPage";
import useIntercom from "../../app/useIntercom";

export default function SupportPage(): React.ReactElement {
  const { showIntercom } = useIntercom();

  return (
    <BusinessPage>
      <Card layout="horizontal">
        <div className="flex w-full flex-col gap-[12px]">
          <div>
            <Label type="title1">Support</Label>
            <p className="mt-1 text-tx-muted">
              We're here to help. Contact us via our live chat for immediate
              assistance.
            </p>
          </div>
          <Button
            text="Open live chat"
            onClick={showIntercom}
            intent="primary"
            weight="outlined"
            loading={showIntercom.loading}
          />
        </div>
      </Card>
    </BusinessPage>
  );
}
